(() => {
  const script = document.querySelector('[data-allgone-events]');
  if (script?.dataset.enabled !== 'true' || window.Shopify?.designMode) return;
  const forms = new WeakMap();
  const confirmations = new WeakSet();
  const services = new Set(['home-cleanouts', 'garage-cleanouts', 'estate-cleanouts',
    'storage-unit-cleanouts', 'furniture-removal', 'mattress-removal', 'couch-removal',
    'appliance-removal', 'construction-debris-removal', 'yard-waste-removal', 'outdoor-junk-removal']);
  const groups = new Set(['home-property-cleanouts', 'furniture-bulky-items', 'appliance-removal',
    'construction-debris-removal', 'yard-outdoor-junk']);
  const catalogTarget = href => {
    const match = href?.match(/^\/(products|collections)\/([a-z-]+)(?:[?#]|$)/);
    if (!match) return null;
    const allowed = match[1] === 'products' ? services : groups;
    return allowed.has(match[2]) ? { kind: match[1] === 'products' ? 'service' : 'group', handle: match[2] } : null;
  };
  const emit = (name, data) => {
    // Fixed metadata only: never include form values, contact details or URLs.
    script.dataset.lastEvent = name;
    script.dataset.eventCount = String(Number(script.dataset.eventCount || 0) + 1);
    document.dispatchEvent(new CustomEvent('allgone:lead_event', { detail: { name, ...data } }));
    try {
      const result = window.Shopify?.analytics?.publish?.(name, data);
      const setStatus = accepted => { script.dataset.publishStatus = accepted === true ? 'accepted' : 'unavailable'; };
      if (result?.then) result.then(setStatus).catch(() => { script.dataset.publishStatus = 'unavailable'; });
      else setStatus(result); // Measurement cannot interrupt a quote request.
    } catch {}
  };
  const surface = node => node.closest('.mobile-quote-dock') ? 'mobile_dock' :
    node.closest('.site-header') ? 'header' : node.closest('.site-footer') ? 'footer' : 'main';
  document.addEventListener('allgone:quote_stage', event => {
    const stage = event.detail?.stage;
    if (['job', 'contact'].includes(stage)) emit('allgone:quote_stage_view', { stage });
  });
  document.addEventListener('allgone:quote_submit_validated', () => {
    emit('allgone:quote_submit_attempt', { surface: 'quote_form' });
  });
  document.addEventListener('allgone:typeform_started', () => {
    emit('allgone:quote_form_start', { surface: 'quote_form' });
  });
  document.addEventListener('allgone:typeform_submitted', () => {
    emit('allgone:quote_confirmation_view', { surface: 'quote_form' });
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;
    if (href.endsWith('#quote')) emit('allgone:quote_open', { surface: surface(link) });
    else if (href.startsWith('tel:')) emit('allgone:contact_click', { channel: 'phone', surface: surface(link) });
    else if (href.startsWith('mailto:')) emit('allgone:contact_click', { channel: 'email', surface: surface(link) });
    const target = catalogTarget(href);
    if (target) emit('allgone:service_click', { ...target, surface: surface(link) });
  });
  const init = root => {
    root.querySelectorAll('[data-form-success]').forEach(node => {
      if (confirmations.has(node)) return;
      confirmations.add(node);
      // A confirmation-page view is not proof of inbox delivery or a unique lead.
      emit('allgone:quote_confirmation_view', { surface: 'quote_form' });
    });
    root.querySelectorAll('[data-quote-flow] form').forEach(form => {
      if (forms.has(form) || form.querySelector('[data-form-success]')) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let started = false;
      const activeStep = [...form.querySelectorAll('[data-step]')].findIndex(node => !node.hidden);
      emit('allgone:quote_stage_view', { stage: activeStep === 1 ? 'contact' : 'job' });
      form.addEventListener('input', () => {
        if (started) return;
        started = true;
        emit('allgone:quote_form_start', { surface: 'quote_form' });
      }, options);
      forms.set(form, controller);
    });
  };
  const boot = () => {
    init(document);
    const target = catalogTarget(window.location.pathname);
    if (target) emit('allgone:service_view', target);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('form').forEach(form => { forms.get(form)?.abort(); forms.delete(form); });
  });
})();
